import getNested from '@/utils/getNested'

const PLACEHOLDER = '—'

/**
 * Returns nested object value. Returns placeholder if data is empty.
 */
const getValue = (...payload) => getNested(...payload) || PLACEHOLDER

export default getValue
